var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, GridCol, GridContainer, GridRow, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Children, Fragment } from 'react';
import { View } from 'react-native';
import { getTitleSectionStyles, getTitleSectionTypography } from './TitleSectionStyles';
import TruncatedText from './components/truncatedText/TruncatedText';
export var TitleSectionComponent = props => {
  var children = props.children,
    title = props.title,
    _props$multiTextTitle = props.multiTextTitle,
    multiTextTitle = _props$multiTextTitle === void 0 ? [] : _props$multiTextTitle,
    _props$multiTextSubTi = props.multiTextSubTitle,
    multiTextSubTitle = _props$multiTextSubTi === void 0 ? [] : _props$multiTextSubTi,
    _props$textAlignment = props.textAlignment,
    textAlignment = _props$textAlignment === void 0 ? 'left' : _props$textAlignment,
    titleSectionContainerStyles = props.titleSectionContainerStyles,
    _props$showSubtitleTr = props.showSubtitleTruncatedText,
    showSubtitleTruncatedText = _props$showSubtitleTr === void 0 ? false : _props$showSubtitleTr,
    truncatedSubtitleProps = props.truncatedSubtitleProps,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? 'BLACK_900' : _props$titleColor,
    subTitle = props.subTitle,
    _props$subTitleColor = props.subTitleColor,
    subTitleColor = _props$subTitleColor === void 0 ? 'BLACK_800' : _props$subTitleColor,
    _props$withParentCard = props.withParentCardWrapper,
    withParentCardWrapper = _props$withParentCard === void 0 ? false : _props$withParentCard,
    _props$withChildrenCa = props.withChildrenCardWrapper,
    withChildrenCardWrapper = _props$withChildrenCa === void 0 ? false : _props$withChildrenCa,
    _props$parentCardNoPa = props.parentCardNoPadding,
    parentCardNoPadding = _props$parentCardNoPa === void 0 ? false : _props$parentCardNoPa,
    _props$childrenCardNo = props.childrenCardNoPadding,
    childrenCardNoPadding = _props$childrenCardNo === void 0 ? false : _props$childrenCardNo,
    _props$gridContainerP = props.gridContainerProps,
    gridContainerProps = _props$gridContainerP === void 0 ? {} : _props$gridContainerP,
    _props$gridRowProps = props.gridRowProps,
    gridRowProps = _props$gridRowProps === void 0 ? {} : _props$gridRowProps,
    _props$gridTitleColPr = props.gridTitleColProps,
    gridTitleColProps = _props$gridTitleColPr === void 0 ? {} : _props$gridTitleColPr,
    _props$gridSubTitleCo = props.gridSubTitleColProps,
    gridSubTitleColProps = _props$gridSubTitleCo === void 0 ? {} : _props$gridSubTitleCo,
    _props$gridColProps = props.gridColProps,
    gridColProps = _props$gridColProps === void 0 ? {} : _props$gridColProps,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$parentCardProp = props.parentCardProps,
    parentCardProps = _props$parentCardProp === void 0 ? {} : _props$parentCardProp,
    _props$childCardProps = props.childCardProps,
    childCardProps = _props$childCardProps === void 0 ? {} : _props$childCardProps,
    _props$isInsideGridCo = props.isInsideGridColumn,
    isInsideGridColumn = _props$isInsideGridCo === void 0 ? false : _props$isInsideGridCo,
    showActionCta = props.showActionCta,
    actionCtaText = props.actionCtaText,
    actionCtaButtonProps = props.actionCtaButtonProps,
    onActionCtaPress = props.onActionCtaPress,
    id = props.id,
    testID = props.testID,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["children", "title", "multiTextTitle", "multiTextSubTitle", "textAlignment", "titleSectionContainerStyles", "showSubtitleTruncatedText", "truncatedSubtitleProps", "titleColor", "subTitle", "subTitleColor", "withParentCardWrapper", "withChildrenCardWrapper", "parentCardNoPadding", "childrenCardNoPadding", "gridContainerProps", "gridRowProps", "gridTitleColProps", "gridSubTitleColProps", "gridColProps", "style", "parentCardProps", "childCardProps", "isInsideGridColumn", "showActionCta", "actionCtaText", "actionCtaButtonProps", "onActionCtaPress", "id", "testID", "onUserAction"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen,
    breakpoint = _useBreakpoint.breakpoint;
  var titleSectionStyles = getTitleSectionStyles(props, breakpoint);
  var typography = getTitleSectionTypography(props, breakpoint);
  var ParentCardWrapper = withParentCardWrapper ? Card : Fragment;
  var ChildCardWrapper = withChildrenCardWrapper ? Card : View;
  var handleForLeftSection = isLargeScreen && isInsideGridColumn;
  var handleForLeftSectionProps = {
    gridContainer: {
      fullWidth: true,
      noMargin: true
    },
    gridRow: {
      noMargin: true
    },
    gridCol: {
      noGutter: true
    }
  };
  return _jsx(GridContainer, Object.assign({
    style: [titleSectionStyles.container, style]
  }, handleForLeftSection && handleForLeftSectionProps.gridContainer, gridContainerProps, restProps, getTestId(testID), {
    children: _jsxs(ParentCardWrapper, Object.assign({}, withParentCardWrapper && {
      noPadding: parentCardNoPadding
    }, parentCardProps, {
      children: [_jsx(GridRow, Object.assign({}, handleForLeftSection && handleForLeftSectionProps.gridRow, gridRowProps, {
        children: (!!title || (multiTextTitle === null || multiTextTitle === void 0 ? void 0 : multiTextTitle.length) > 0) && _jsx(GridCol, Object.assign({}, handleForLeftSection && handleForLeftSectionProps.gridCol, gridTitleColProps, {
          style: [titleSectionStyles.titleContainer, gridTitleColProps.style]
        }, {
          children: _jsxs(View, Object.assign({
            style: [titleSectionStyles.actionCtaAndTitleContainer, titleSectionContainerStyles]
          }, {
            children: [_jsx(Typography, Object.assign({
              type: typography.titleType,
              text: title,
              color: titleColor,
              multiText: multiTextTitle,
              textAlignment: textAlignment
            }, getTestId(testID, 'title'))), showActionCta && _jsx(Button, Object.assign({
              title: actionCtaText,
              buttonType: "tertiary",
              style: titleSectionStyles.actionCtaStyle,
              onPress: () => {
                onActionCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                  id
                }, onActionCtaPress), props));
              }
            }, actionCtaButtonProps, getTestId(testID, 'button')))]
          }))
        }))
      })), _jsx(GridRow, Object.assign({}, handleForLeftSection && handleForLeftSectionProps.gridRow, gridRowProps, {
        children: (!!subTitle || (multiTextSubTitle === null || multiTextSubTitle === void 0 ? void 0 : multiTextSubTitle.length) > 0) && _jsx(GridCol, Object.assign({
          noTopGutter: true
        }, handleForLeftSection && handleForLeftSectionProps.gridCol, gridSubTitleColProps, {
          style: [titleSectionStyles.subTitleContainer, gridSubTitleColProps.style]
        }, {
          children: showSubtitleTruncatedText && truncatedSubtitleProps ? _jsx(TruncatedText, Object.assign({
            text: subTitle
          }, truncatedSubtitleProps, {
            type: typography.subTitleType,
            color: subTitleColor
          }, getTestId(testID, 'subTitle'))) : _jsx(Typography, Object.assign({
            multiText: multiTextSubTitle,
            type: typography.subTitleType,
            text: subTitle,
            color: subTitleColor
          }, getTestId(testID, 'subTitle')))
        }))
      })), _jsx(GridRow, Object.assign({}, handleForLeftSection && handleForLeftSectionProps.gridRow, gridRowProps, {
        children: Children.count(children) > 0 && _jsx(GridCol, Object.assign({}, handleForLeftSection && handleForLeftSectionProps.gridCol, gridColProps, {
          noTopGutter: true
        }, {
          children: _jsx(ChildCardWrapper, Object.assign({}, withChildrenCardWrapper && {
            noPadding: childrenCardNoPadding
          }, childCardProps, {
            style: [titleSectionStyles.childContainer, childCardProps === null || childCardProps === void 0 ? void 0 : childCardProps.style]
          }, {
            children: children
          }))
        }))
      }))]
    }))
  }));
};
TitleSectionComponent.genericRendererKey = 'AirTitleSection';
TitleSectionComponent.isAirSection = true;
export var TitleSection = TitleSectionComponent;